export interface ConfigState {
    homeRoute: string | undefined;
    simulationRoute: string | undefined;
    id: string | undefined;
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
}

export const config: ConfigState = {
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    simulationRoute: import.meta.env.VITE_SIMULATION_ROUTE,
    id: import.meta.env.VITE_ENV_CONFIG,
    serviceVersion: APP_VERSION,
    serviceEnvironment: import.meta.env.MODE,
    // Dev-only, and opt-out via VITE_ENABLE_MOCK_SERVER=false so a local run can hit a real
    // environment. Absent or any other value keeps mocks on, which is the default dev experience.
    enableMockServer: import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCK_SERVER !== 'false',
};
